'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import FollowDialogContent from '@/components/FollowDialogContent';
import ViverseDialog from '@/components/ViverseDialog';
import { UseFollowDataReturnType } from '@/hooks/useFollowData';
export enum FollowDialogType {
  Followings = 'followings',
  Followers = 'followers',
}
type FollowDialogProps = {
  dialogType: FollowDialogType;
} & UseFollowDataReturnType;
function FollowDialog(t0) {
  const $ = _c(39);
  let count;
  let data;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      dialogType: t1,
      data,
      count,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = count;
    $[2] = data;
    $[3] = rest;
    $[4] = t1;
  } else {
    count = $[1];
    data = $[2];
    rest = $[3];
    t1 = $[4];
  }
  const dialogType = t1 === undefined ? FollowDialogType.Followings : t1;
  const t = useTranslations();
  const [isOpen, setIsOpen] = useState(false);
  const searchParams = useSearchParams();
  let t2;
  if ($[5] !== searchParams) {
    t2 = searchParams.get("dialog");
    $[5] = searchParams;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const followParam = t2;
  let t3;
  if ($[7] !== t) {
    t3 = t("profile-page.intro-dialog-following-title");
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t) {
    t4 = t("profile-page.intro-dialog-follower-title");
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = {
      followings: t3,
      followers: t4
    };
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const FOLLOW_DIALOG_TITLE = t5;
  let t6;
  if ($[14] !== t) {
    t6 = t("profile-page.intro-following");
    $[14] = t;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t) {
    t7 = t("profile-page.intro-followers");
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = {
      followings: t6,
      followers: t7
    };
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const COUNT_TITLE = t8;
  const title = FOLLOW_DIALOG_TITLE[dialogType];
  const followDataList = data[dialogType];
  let t10;
  let t9;
  if ($[21] !== dialogType || $[22] !== followParam) {
    t9 = () => {
      if (followParam && dialogType === followParam) {
        setIsOpen(true);
      }
    };
    t10 = [followParam, dialogType];
    $[21] = dialogType;
    $[22] = followParam;
    $[23] = t10;
    $[24] = t9;
  } else {
    t10 = $[23];
    t9 = $[24];
  }
  useEffect(t9, t10);
  const t11 = count[dialogType];
  let t12;
  if ($[25] !== t11) {
    t12 = <p className="subheader-3 md:subheader-2 text-white">{t11}</p>;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  const t13 = COUNT_TITLE[dialogType];
  let t14;
  if ($[27] !== t12 || $[28] !== t13) {
    t14 = <div className="body-1 flex cursor-pointer items-center gap-1 max-md:text-[14px]">{t12}{t13}</div>;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== dialogType || $[31] !== followDataList || $[32] !== rest) {
    t15 = <FollowDialogContent {...rest} followDataList={followDataList} type={dialogType} className="items-stretch" />;
    $[30] = dialogType;
    $[31] = followDataList;
    $[32] = rest;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== isOpen || $[35] !== t14 || $[36] !== t15 || $[37] !== title) {
    t16 = <ViverseDialog title={title} open={isOpen} onOpenChange={setIsOpen} dialogTrigger={t14} contentClassName="w-[calc(100%-40px)] max-w-[448px] max-h-[468px] lg:w-[448px] lg:min-w-[448px]" childrenClassName="w-full max-h-[calc(468px-102px)] 1.5xl:max-h-[calc(468px-110px)]">{t15}</ViverseDialog>;
    $[34] = isOpen;
    $[35] = t14;
    $[36] = t15;
    $[37] = title;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  return t16;
}
export default FollowDialog;